import {Almacen} from './Almacen';

export class Solicitante {
  public id: number = -1;
  public idSolicitante: string = "";
  public solicitante: string = "";
  public almacen: Almacen = new Almacen();
  public estado: boolean = true;
  public telefono: string = "";
  public otrosDatos: string = "";
  public mail: string | null = null;
  public ptoEmision: string = "0015";
  public balanza: string = "";
  public usrCreacion: string = "";
  public fecCreacion: Date = new Date();
  public usrModif: string | null = null;
  public fecModif: Date | null = null;
}
